import { decrypt } from '../../../../core/cryptor/cipher';
import { ResultWithOptionalError } from '../../../../core/types/generic/results';
import { doesFileExist, readFileContents } from '../../commonUtils';
import { getInitialSnapshotInfo, getWALDBName } from '../../helpers';
import { FileSystemWALInfo } from '../../types';

// export const getInitialWALInfoFS = (): FileSystemWALInfo => ({
//   recordsInfo: {
//     serialStart: 0,
//     lastAddedRecord: 0,
//   },
//   verifiedSerials: {},
// });

export const getSnapshotInfoFS = async (
  fileHandle: FileSystemFileHandle,
  feKey: CryptoKey
) => {
  try {
    const encSnapshotInfo = await readFileContents(fileHandle);
    if (encSnapshotInfo) {
      const decSnapshotInfo = await decrypt(encSnapshotInfo, feKey);
      return decSnapshotInfo
        ? JSON.parse(decSnapshotInfo)
        : getInitialSnapshotInfo();
    }
  } catch (err) {
    return getInitialSnapshotInfo();
  }

  return getInitialSnapshotInfo();
};

export const getSnapshotFileHandlers = async (
  parentDirectoryHandle: FileSystemDirectoryHandle,
  id: string
) => {
  const directoryHandle = await parentDirectoryHandle.getDirectoryHandle(id, {
    create: true,
  });
  // const t1 = performance.now();
  const snap = await directoryHandle.getFileHandle(`snapshot.txt`, {
    create: true,
  });
  // const t2 = performance.now();
  // console.log('file system performance', t2 - t1, id);
  const meta = await directoryHandle.getFileHandle(`snapMeta.txt`, {
    create: true,
  });

  return {
    directoryHandle,
    snap,
    meta,
  };
};

export const getWALFileHandlers = async (
  directoryHandle: FileSystemDirectoryHandle,
  activeWAL: number
) => {
  const walMetaFileName = `${activeWAL}-meta.txt`;
  const isExist = await doesFileExist(directoryHandle, walMetaFileName);
 
  const wal = await directoryHandle.getFileHandle(`${activeWAL}.txt`, {
    create: true,
  });
 
  const meta = await directoryHandle.getFileHandle(walMetaFileName, {
    create: true,
  });
  const verifiedSerials = await directoryHandle.getFileHandle(
    `${activeWAL}-verified.txt`,
    { create: true }
  );

  return {
    wal,
    meta,
    verifiedSerials,
    isExist,
  };
};

// export const getFileHandlers = async (
//   parentDirectoryHandle: FileSystemDirectoryHandle,
//   baseId: string,
//   fileId: string
// ) => {
//   const fileName = `${fileId}.txt`;
//   const infoFileName = `${fileId}-info.json`;
//   const directoryHandle = await parentDirectoryHandle.getDirectoryHandle(
//     baseId,
//     {
//       create: true,
//     }
//   );
//   const fileHandle = await directoryHandle.getFileHandle(fileName, {
//     create: true,
//   });
//   const infoFileExist = await doesFileExist(directoryHandle, infoFileName);
//   const infoFileHandle = await directoryHandle.getFileHandle(infoFileName, {
//     create: true,
//   });
//   return {
//     directoryHandle,
//     fileHandle,
//     infoFileExist,
//     infoFileHandle,
//   };
// };
